module.exports = __webpack_public_path__ + "img/2.d5506c91.jpg";